import { HubConnection } from "@microsoft/signalr";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUser } from "../../types/IUser";

export type ActiveUsers = {
    ticketId: number,
    users: IUser[]
}

const ticketViewSlice = createSlice({
    name: "ticketViewSlice",
    initialState: {
        activeUsers: {},
        connection: null as HubConnection
    },
    reducers: {
        setActiveUsers: (state, action: PayloadAction<ActiveUsers>) => {
            state.activeUsers[action.payload.ticketId] = action.payload.users;
        },
        setConnection: (state, action: PayloadAction<HubConnection>) => {
            state.connection = action.payload;
        },
        ticketConnect: (state, action: PayloadAction<{ tenantId: string, ticketId: number, user: IUser }>) => {
            // ticket connection handled in the middleware
            console.log('Ticket connected:', action.payload.ticketId);
        },
        ticketDisconnect: (state, action: PayloadAction<{ tenantId: string, ticketId: number, user: IUser }>) => {
            // ticket disconnection handled in the middleware
            console.log('Ticket disconnected:', action.payload.ticketId);
        },
    }
});

export const { setActiveUsers, ticketConnect, ticketDisconnect, setConnection } = ticketViewSlice.actions;
export default ticketViewSlice;

